export default "__VITE_ASSET__9f1beV7N__"